import { useEffect, useState } from 'react';

/** Persisted dark-mode toggle + chrome i18n for the developer portal. */
export function useDarkMode(): [boolean, () => void] {
  const [dark, setDark] = useState<boolean>(() => {
    try { return localStorage.getItem('theme') === 'dark'; } catch { return false; }
  });
  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add('dark'); else root.classList.remove('dark');
    try { localStorage.setItem('theme', dark ? 'dark' : 'light'); } catch { /* ignore */ }
  }, [dark]);
  return [dark, () => setDark((d) => !d)];
}

const NAV: Record<string, Record<string, string>> = {
  en: { Applications: 'Applications', 'API Reference': 'API Reference', Guides: 'Guides', Webhooks: 'Webhooks', Usage: 'Usage', Playground: 'Playground', Status: 'Status', Components: 'Components', 'Sign out': 'Sign out' },
  es: { Applications: 'Aplicaciones', 'API Reference': 'Referencia API', Guides: 'Guías', Webhooks: 'Webhooks', Usage: 'Uso', Playground: 'Entorno de pruebas', Status: 'Estado', Components: 'Componentes', 'Sign out': 'Cerrar sesión' },
  fr: { Applications: 'Applications', 'API Reference': 'Référence API', Guides: 'Guides', Webhooks: 'Webhooks', Usage: 'Utilisation', Playground: 'Bac à sable', Status: 'État', Components: 'Composants', 'Sign out': 'Se déconnecter' },
};
export const getLocale = () => { try { return localStorage.getItem('locale') || 'en'; } catch { return 'en'; } };
export const setLocale = (l: string) => { try { localStorage.setItem('locale', l); } catch { /* ignore */ } window.location.reload(); };
export const useChromeT = () => { const loc = getLocale(); return (s: string) => NAV[loc]?.[s] ?? s; };
